import React from "react";

import SectionTitle from "../../components/SectionTitle";

import SingleService from "../../components/Service/SingleService";

import serviceImg1 from "../../assets/images/service/1.jpg";
import serviceImg2 from "../../assets/images/service/2.jpg";
import serviceImg3 from "../../assets/images/service/3.jpg";

import { Link } from "react-router-dom";

const Service = () => {
  return (
    <div className="react_popular_topics pb---70">
      <div className="container">
        <SectionTitle Title="Our Courses" />
        <div className="row">
          <div
            className="col-lg-3 wow animate__fadeInUp"
            data-wow-duration="0.3s"
          >
            <Link to={"/adult"}>
              <SingleService
                itemImg={serviceImg1}
                title="French for Adults Courses"
              />
            </Link>
          </div>
          <div
            className="col-lg-3 wow animate__fadeInUp"
            data-wow-duration="0.5s"
          >
            <Link to={"/kid"}>
              <SingleService
                itemImg={serviceImg2}
                title="French for Kids Courses"
              />
            </Link>
          </div>
          <div
            className="col-lg-3 wow animate__fadeInUp"
            data-wow-duration="0.7s"
          >
            <Link to={"/native"}>
              <SingleService
                itemImg={serviceImg3}
                title="Native French Courses"
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
